<template>
  <div>
    <div v-if="showDetail">
      <van-cell title="就诊信息" title-class="van-cell__title_left">
        <template #icon>
          <van-icon
            name="pause"
            color="#BC1418"
            size="18"
            style="margin-top: 4px; margin-right: 2px"
          />
        </template>
      </van-cell>
      <van-cell
        title-class="van-cell__title_left"
        title="就诊医院:"
        :value="this.GLOBAL.hosName"
      ></van-cell>
      <van-cell
        title-class="van-cell__title_left"
        title="就诊人:"
        :value="payResultInfo.userName"
      ></van-cell>
      <van-cell
        title-class="van-cell__title_left"
        title="就诊登记号:"
        :value="payResultInfo.cardNo"
      ></van-cell>
      <van-cell
        title-class="van-cell__title_left"
        title="医院订单号:"
        :value="payResultInfo.medOrgOrd"
      ></van-cell>
      <van-cell title="订单详情" title-class="van-cell__title_left">
        <template #icon>
          <van-icon
            name="pause"
            color="#BC1418"
            size="18"
            style="margin-top: 4px; margin-right: 2px"
          />
        </template>
      </van-cell>
      <van-cell
        title-class="van-cell__title_left"
        title="费用总金额:"
        :value="payResultInfo.feeSumamt"
      ></van-cell>
      <van-cell
        title-class="van-cell__title_left"
        title="现金支付:"
        :value="payResultInfo.ownPayAmt"
      ></van-cell>
      <van-cell
        title-class="van-cell__title_left"
        title="个人账户支付:"
        :value="payResultInfo.psnAcctPay"
      ></van-cell>
      <van-cell
        title-class="van-cell__title_left"
        title="医保基金支付:"
        :value="payResultInfo.fundPay"
      ></van-cell>
      <van-cell
        title-class="van-cell__title_left"
        title="缴费状态:"
        :value="this.success == 'true' ? '已结算' : '未结算'"
      ></van-cell>
    </div>
    <div v-if="!showDetail">
      <van-cell
        title-class="van-cell__title_left"
        title="缴费状态:"
        :value="this.success == 'true' ? '已结算' : '未结算'"
      ></van-cell>
      <van-cell title-class="van-cell__title_left" title="结果说明:">
        <template #label>
          <div
            style="
              word-break: normal;
              width: auto;
              display: block;
              white-space: pre-wrap;
              word-wrap: break-word;
              overflow: hidden;line-height: 12px;
            "
          >
            {{ message }}
          </div>
        </template>
      </van-cell>
    </div>
    <div style="margin: 16px">
      <van-button
        round
        block
        type="primary"
        native-type="submit"
        @click.native="goOrders"
        color="#0D7CFF"
      >
        返回
      </van-button>
    </div>
  </div>
</template>
  <script>
import { CellGroup } from "vant";
import { ref } from "vue";
import requests from "../../api/requests.js";
import { Form, Field, Button, Dialog, Toast } from "vant";

export default {
  data() {
    return {
      //支付页面传入信息
      payResultInfo: {},
      //是否成功
      success: "false",
      //结果说明
      message: "",
      //结算流水号
      balanceId: "",
      //展示详情还是展示错误信息
      showDetail: true,
      //wx支付状态查询
      OrderQueryRequestInfo: {
        med_trans_id: "",
        hosp_out_trade_no: "",
      },
    };
  },
  created() {
    // this.payInfo = this.$route.query.order;
    // this.payInfo = JSON.parse(localStorage.getItem("order")).item;
    let ptype = localStorage.getItem(this.GLOBAL.hosUrl + "-ptype");
    let openid = localStorage.getItem(this.GLOBAL.hosUrl);
    let payOrdId = localStorage.getItem(this.GLOBAL.hosUrl + "-payOrdId");
    let med_trans_id = localStorage.getItem(
      this.GLOBAL.hosUrl + "-med_trans_id"
    );
    let hospOutTradeNo = localStorage.getItem(
      this.GLOBAL.hosUrl + "-hospOutTradeNo"
    );
    let serialNo = localStorage.getItem(this.GLOBAL.hosUrl + "-serialNo");

    Toast.loading({
      duration: 0,
      forbidClick: true,
      overlay: true,
      message: "加载中...",
    });

    this.queryOders(
      payOrdId,
      openid,
      med_trans_id,
      hospOutTradeNo,
      serialNo,
      ptype
    );
  },
  methods: {
    goOrders() {
      this.$router.push({ path: "/orders" });
    },
    //支付结果通知his系统
    queryPay(payOrdId, openid, medTransId, hospOutTradeNo, serialNo, ptype) {
      const that = this;
      let api = "queryPay";
      if (ptype == "wx") {
        api = "QuerySelfPay";
      }

      let httpURL =
        "/His/" +
        api +
        "?openid=" +
        openid +
        "&hospOutTradeNo=" +
        hospOutTradeNo +
        "&payOrdId=" +
        payOrdId +
        "&medTransId=" +
        medTransId +
        "&serialNo=" +
        serialNo;
      // alert(httpURL);

      requests
        .get(httpURL)
        .then(function (res) {
          // alert(JSON.stringify(res));
          if (res.data != null) {
            that.payResultInfo = res.data.data;
            that.success = res.data.success;
            that.message = res.data.message;
            that.balanceId = res.data.balanceId;
            if (res.data.success == "true") {
              that.showDetail = true;
            } else {
              that.showDetail = false;
            }
          }
        })
        .finally((res) => {
          Toast.clear();
        });
    },
    convertMedTradeState(med_trade_state) {
      switch (med_trade_state) {
        case "REFUND":
          return "转入退款";
        case "PAYING":
          return "支付中";
        case "SYS_REFUNDED":
          return "支付失败";
        case "SYS_REFUNDING":
          return "支付失败，异常处理中";
        case "NOTPAY":
          return "未支付";
        case "CLOSED":
          return "已关闭";
        case "INITIAL":
          return "未绑卡";
        default:
          return "未知";
      }
    },
    //查询wx支付状态
    queryOders(payOrdId, openid, medTransId, hospOutTradeNo, serialNo, ptype) {
      let that = this;
      let httpURL = "/PayInsurance/queryorder?openid=" + openid;
      that.OrderQueryRequestInfo.med_trans_id = medTransId;
      that.OrderQueryRequestInfo.hosp_out_trade_no = hospOutTradeNo;

      requests
        .post(httpURL, JSON.stringify(that.OrderQueryRequestInfo))
        .then(function (res) {
          if (res.data != null) {
            if (res.data.return_code == "SUCCESS") {
              //支付成功
              // SUCCESS—支付成功
              // REFUND—转入退款
              // PAYING—支付中
              // SYS_REFUNDED-支付失败
              // SYS_REFUNDING-支付失败，异常处理中
              // NOTPAY—未支付
              // CLOSED—已关闭
              // INITIAL—未绑卡
              if (res.data.result_code == "SUCCESS") {
                if (res.data.med_trade_state == "SUCCESS") {
                  // alert('here');
                  //告诉his支付成功
                  that.queryPay(
                    payOrdId,
                    openid,
                    medTransId,
                    hospOutTradeNo,
                    serialNo,
                    ptype
                  );
                } else {
                  //是否成功
                  that.success = false;
                  //结果说明
                  that.message = that.convertMedTradeState(res.data.med_trade_state);
                  //展示详情还是展示错误信息
                  that.showDetail = false;
                }
              } else {
                //是否成功
                that.success = false;
                //结果说明
                that.message = res.data.err_code_des;
                //展示详情还是展示错误信息
                that.showDetail = false;
              }
            }
          }
        })
        .finally((res) => {
          Toast.clear();
        });
    },
  },
};
</script>
  <style scoped>
.money {
  font-weight: bold;
  color: coral;
}
.c1 {
  width: 0.625rem;
  height: 0.625rem;
}

.mine_headicon {
  width: 150rpx;
  height: 150rpx;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

.search-icon {
  font-size: 16px;
  line-height: inherit;
  color: #12c014;
}

.search-icon.dis {
  font-size: 16px;
  line-height: inherit;
  color: #e0dee1;
}

.van-cell__title_left {
  min-width: 50%;
  text-align: left;
}
.van-cell__value {
  min-width: 50%;
  span {
    display: inline-block;
    text-align: left;
    word-break: break-all;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/views/payResult/index.vue